// src/utils/Geocoding.ts
export class Geocoding {
  static NOMINATIM_URL = "https://nominatim.openstreetmap.org/reverse";

  /**
   * Reverse geocode coordinates into an address using Nominatim.
   * @param lat Latitude
   * @param lon Longitude
   * @returns Address string (if found), otherwise null
   */
  static async reverseGeocode(
    lat?: number,
    lon?: number
  ): Promise<string | null> {
    if (lat === undefined || lon === undefined) {
      return null;
    }

    try {
      const url = `${this.NOMINATIM_URL}?format=json&lat=${lat}&lon=${lon}&addressdetails=1`;
      const response = await fetch(url, {
        headers: {
          "User-Agent": "YourAppName/1.0 (your@email.com)",
          "Accept-Language": "en",
        },
      });

      if (!response.ok) {
        throw new Error(`Nominatim request failed: ${response.status}`);
      }

      const data = await response.json();
      return data?.display_name ?? null;
    } catch (error) {
      console.error("Geocoding error:", error);
      return null;
    }
  }
}
